import { SuperFetch } from '@quotient/riq-helpers';

export function signOut() {
  const signOutEndpoint = `/pu/signin/`;

  return SuperFetch.get(signOutEndpoint)
    .then((result: any) => {
      window !== undefined && window.location.reload(true);
    })
    .catch((err: any) => {
      console.warn(err);
    });
}
